import React from 'react'

import { useKindeLoginLogic } from './KindeLogin.logic'
import { KindeLoginView } from './KindeLogin.view'

function KindeLogin() {
  const logicResults = useKindeLoginLogic()

  return <KindeLoginView {...logicResults} />
}

export { KindeLogin }
